<template>
  <div>
    <div style="margin: 4rem 3rem">
      <div
        v-if="manufacturer"
        class="well"
        style="padding: 2rem 3rem; margin-bottom: 3rem"
      >
        <h4>Manufacturer details</h4>
        <table style="margin-bottom: 2rem">
          <tbody>
            <tr>
              <th class="manufacturer-info-header">Company name</th>
              <td>{{ manufacturer.name }}</td>
            </tr>
            <tr>
              <th class="manufacturer-info-header">Primary email</th>
              <td v-if="manufacturer.email">
                {{ manufacturer.email }}
              </td>
              <td v-else class="text-danger">Missing</td>
            </tr>
            <tr>
              <th class="manufacturer-info-header">Primary phone</th>
              <td v-if="manufacturer.phone">
                {{ manufacturer.phone }}
              </td>
              <td v-else class="text-danger">Missing</td>
            </tr>
            <tr>
              <th class="manufacturer-info-header">Website URL</th>
              <td v-if="manufacturer.website_url">
                {{ manufacturer.website_url }}
              </td>
              <td v-else class="text-danger">Missing</td>
            </tr>
            <tr>
              <th class="manufacturer-info-header">Invoice Terms</th>
              <td v-if="manufacturer.terms">
                {{ manufacturer.terms.name }}
              </td>
              <td v-else class="text-danger">Missing</td>
            </tr>
          </tbody>
        </table>
        <small>
          The details in this section are provided by QuickBooks and cannot be
          modified here. If any changes are necessary, those changes
          <em>must</em> be made within QuickBooks Online.
        </small>
      </div>
      <div class="well" style="padding: 2rem 3rem; margin-bottom: 3rem">
        <h4>Inside sales contact details</h4>
        <table style="margin-bottom: 2rem">
          <tbody>
            <tr>
              <th class="manufacturer-info-header">Contact name</th>
              <td v-if="salesContactName">{{ salesContactName }}</td>
              <td v-else class="text-danger">Missing</td>
            </tr>
            <tr>
              <th class="manufacturer-info-header">Contact email</th>
              <td v-if="salesContactEmail">{{ salesContactEmail }}</td>
              <td v-else class="text-danger">Missing</td>
            </tr>
            <tr>
              <th class="manufacturer-info-header">Contact phone</th>
              <td v-if="salesContactPhone">{{ salesContactPhone }}</td>
              <td v-else class="text-danger">Missing</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div style="display: flex; flex-flow: row; justify-content: space-between">
      <button class="btn btn-secondary" @click="handlePrev">Back</button>
      <button
        class="btn btn-primary"
        :disabled="submitting"
        @click="handleNext"
      >
        Submit
      </button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters({
      manufacturer: "manufacturer/getManufacturerPayload",
      salesContactName: "manufacturer/getSalesContactName",
      salesContactEmail: "manufacturer/getSalesContactEmail",
      salesContactPhone: "manufacturer/getSalesContactPhone",
      submitting: "manufacturer/getSubmitting",
    }),
  },
  methods: {
    handlePrev() {
      this.$emit("prev");
    },
    handleNext() {
      this.$emit("next");
    },
  },
};
</script>

<style scoped>
.manufacturer-info-header {
  text-align: right;
  vertical-align: top;
  padding-bottom: 0.5rem;
  padding-right: 1rem;
}
</style>
